import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import { useAuth } from '../../hooks/useAuth';
import { Formik, Form as FormikForm } from 'formik';
import FormField from '../layout/FormField';
import Select from 'react-select';

import { selectorStyles } from '../Agencies/AddAgencies';
import { errorMessageString } from '../../helpers/utils';

let transitValues = [
    { value: 'subway', label: 'Subway', name: 'subwayPrice', placeholder: 'Subway Price' },
    { value: 'train', label: 'Train', name: 'trainPrice', placeholder: 'Train Price' },
    { value: 'streetcar', label: 'Street Car', name: 'carPrice', placeholder: 'Car Price' },
    { value: 'bus', label: 'Bus', name: 'busPrice', placeholder: 'Bus Price' }
];
const BookingsConfigForm = () => {
    const { getToken, user, handleUserData } = useAuth();
    const [units, setAllUnits] = useState();
    const [transitAgency, setTransitAgency] = React.useState('');
    const [transitType, setTransitType] = useState([]);
    const [transitOptions, setTransitOptions] = useState(transitValues);

    const navigate = useNavigate();

    useEffect(() => {
        if (!transitAgency || !Array.isArray(transitAgency?.transit_mediums)) return;

        let transitAgencies = transitAgency.transit_mediums.map((row) => transitValues.find((transit) => transit?.value === row)).filter(Boolean); // Removes undefined values

        setTransitOptions(transitAgencies);
    }, [transitAgency]);

    useEffect(() => {
        let data = [];
        if (transitAgency?.bookings_config) {
            Object.keys(transitAgency?.bookings_config).forEach((key) => {
                let foundKey = transitOptions.find((row) => row?.name === key);
                if (foundKey !== -1) {
                    data.push(foundKey);
                }
            });
            setTransitType([...data]);
        }
    }, [transitAgency?.bookings_config]);

    const handleSubmit = async (values, actions) => {
        try {
            if (transitType?.length === 0) {
                toast.error('Please select atleast one.');
                return;
            }
            let bodyData = {};
            Object.keys(values).forEach((key) => {
                let foundKey = transitType.find((row) => row?.name === key);
                if (foundKey) {
                    bodyData[key] = values[key];
                } else {
                    bodyData[key] = undefined;
                }
            });

            const token = getToken();
            if (token) {
                new WebApiCalls()
                    .updateUserBookingConfig(token, bodyData)
                    .then((res) => {
                        if (res?.code == 200) {
                            handleUserData(res?.data);
                            toast.success('Fare settings updated successfully.');
                        }
                    })
                    .catch((err) => {
                        let errorMessage = errorMessageString(err);

                        toast.error(errorMessage);
                    });
            } else {
                toast.error('Oops...! Something went wrong');
            }

            //
        } catch (error) {
            console.log(error);
        }
    };
    const getMeasuredUnits = async () => {
        const token = getToken();
        if (token) {
            new WebApiCalls()
                .getRewardSettings(token)
                .then((res) => {
                    if (res?.code == 200) {
                        setAllUnits(res?.data);
                    }
                })
                .catch((err) => {
                    let errorMessage = errorMessageString(err);

                    toast.error(errorMessage);
                });
        }
    };
    const getTransitAgency = async () => {
        const token = getToken();
        if (token) {
            new WebApiCalls()
                .getSingleAgency(token, user?.transit_agency)
                .then((res) => {
                    if (res?.code == 200) {
                        setTransitAgency(res?.data);
                    }
                })
                .catch((err) => {
                    let errorMessage = errorMessageString(err);

                    toast.error(errorMessage);
                });
        }
    };
    useEffect(() => {
        getMeasuredUnits();
        getTransitAgency();
    }, []);
    return (
        <Row className="d-flex justify-content-center">
            <Col xs={12} sm={12} md={11} lg={11} className="shadow-lg p-5 rounded m-3">
                <Formik
                    initialValues={{
                        busPrice: transitAgency?.bookings_config?.busPrice || '',
                        trainPrice: transitAgency?.bookings_config?.trainPrice || '',
                        carPrice: transitAgency?.bookings_config?.carPrice || '',
                        subwayPrice: transitAgency?.bookings_config?.subwayPrice || ''
                    }}
                    onSubmit={handleSubmit}
                    enableReinitialize={true}
                >
                    {(formik) => (
                        <FormikForm
                            onSubmit={(e) => {
                                e.preventDefault();
                                formik.handleSubmit();
                            }}
                        >
                            <Row>
                                <Col xs={12} sm={12} md={12} lg={12} className="mb-5">
                                    <Form.Group>
                                        <Form.Label className="form-label mb-2">Transit Type</Form.Label>
                                        <Select options={transitOptions} isMulti customStyles={selectorStyles} value={transitType} onChange={(e) => setTransitType(e)} />
                                    </Form.Group>
                                </Col>
                                {transitType?.map((row) => {
                                    return (
                                        <>
                                            <Col xs={12} sm={12} md={6} lg={6} className="mb-3 ">
                                                <FormField
                                                    className="form-control common-input text-end" // Add 'text-end' for right alignment
                                                    label={'Flat fee'}
                                                    name={row?.name}
                                                    type="text" // Change to "text" to allow flexible input
                                                    placeholder={row?.placeholder}
                                                    value={formik.values[row?.name] || '0.00'} // Default to "0.00"
                                                    onChange={(e) => {
                                                        let value = e.target.value;

                                                        // Allow only valid numbers and decimals
                                                        if (/^\d*\.?\d{0,2}$/.test(value)) {
                                                            formik.setFieldValue(row?.name, value);
                                                        }
                                                    }}
                                                    onBlur={(e) => {
                                                        let value = e.target.value;

                                                        // Ensure the value is formatted to two decimal places on blur
                                                        if (value === '' || isNaN(value)) {
                                                            value = '0.00';
                                                        } else {
                                                            value = parseFloat(value).toFixed(2);
                                                        }
                                                        formik.setFieldValue(row?.name, value);
                                                    }}
                                                    required
                                                />
                                            </Col>

                                            <Col xs={12} sm={12} md={6} lg={6} className="mb-3">
                                                <Form.Group>
                                                    <Form.Label className="form-label mb-2">Distance Unit</Form.Label>
                                                    <div className="form-control-plaintext">{units?.distanceUnit || 'N/A'}</div>
                                                </Form.Group>
                                            </Col>
                                        </>
                                    );
                                })}
                            </Row>

                            <div className="text-end justify-content-end d-flex">
                                <Link to="/">
                                    <Button className="theme-cancel-btn me-3">Cancel</Button>
                                </Link>
                                <Button type="submit" className="theme-btn">
                                    Save
                                </Button>
                            </div>
                        </FormikForm>
                    )}
                </Formik>
            </Col>
        </Row>
    );
};

export default BookingsConfigForm;
